export default __webpack_public_path__ + "static/media/Vambraces of Reckless Challenge.6ebdf3ce.jpg";